// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__5T3O6","containerItemsCenter":"Skeleton_containerItemsCenter__1C01g"};